import { ICON_DEFAULT_COLOR, ICON_DEFAULT_SIZE } from '@constants/icons';
import { IconProps } from '@models/icons';

function PaperLineIcon({ size = ICON_DEFAULT_SIZE, color = ICON_DEFAULT_COLOR, ...rest }: IconProps) {
    return (
        <svg width={size} height={size}
            className='icon'
            viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"
            {...rest} >
            <g transform="translate(2 3)">
                <path d="M1 3C1 1.89543 1.89543 1 3 1H13C14.1046 1 15 1.89543 15 3V17H3C1.89543 17 1 16.1046 1 15V3Z"
                    stroke={color} strokeWidth="2"/>
                <path d="M15 16C14.4477 16 14 16.4477 14 17C14 17.5523 14.4477 18 15 18V17V16ZM15 9V10H17.9361V9V8H15V9ZM19 10.0639H18V15H19H20V10.0639H19ZM17 17V16H15V17V18H17V17ZM19 15H18C18 15.5523 17.5523 16 17 16V17V18C18.6569 18 20 16.6569 20 15H19ZM17.9361 9V10C17.9714 10 18 10.0286 18 10.0639H19H20C20 8.92404 19.076 8 17.9361 8V9Z"
                    fill={color}/>
                <path d="M5 7H11" stroke={color} strokeWidth="2" strokeLinecap="round"/>
                <path d="M5 11H11" stroke={color} strokeWidth="2" strokeLinecap="round"/>
            </g>
        </svg>
    );
}

export default PaperLineIcon;
